<template>
  <div class="bank_running_water" v-loading='loading'>
    <div class="header_change">
      <el-row>
        <el-col :span='12'>
          <div class="zhangqi_change">
            <el-select v-model="fkBankContractId" size="small" @change="changeBlank_Task" ref='select_blank'>
              <el-option v-for="item in blank_list" :key="item.bankCardNo" :label="item.abbreviation"
                :value="item.bankCardNo">
                  <span style="float: left">{{ item.abbreviation }}</span>
                  <span style="float: right;" v-if="item.id">
                    <i class="el-icon-edit" @click.stop="editTask(item)"></i>
                  </span>
              </el-option>
            </el-select>
            <el-popover placement="bottom-start" width="650" v-model="searchModel" trigger="manual" :tabindex='1'>
              <el-form :model='search_form' ref='searchForm' label-width="90px" style="margin:20px 0;">
                <el-form-item label="交易日期">
                  <el-date-picker v-model="search_form.yearMonth" type="daterange" size="small" style="width: 230px;"
                    :picker-options='pickerOptions' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="收入类型">
                  <el-radio-group v-model="search_form.incomeType" style="margin-left:10px;">
                    <el-radio label="all">全部</el-radio>
                    <el-radio label="1">收入</el-radio>
                    <el-radio label="0">支出</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="凭证类型">
                  <el-radio-group v-model="search_form.voucherType" style="margin-left:10px;">
                    <el-radio label="all">全部</el-radio>
                    <el-radio label="1">已生成</el-radio>
                    <el-radio label="0">未生成</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="回单状态">
                  <el-radio-group v-model="search_form.receiptState" style="margin-left:10px;">
                    <el-radio label="all">全部</el-radio>
                    <el-radio label="0">未生成</el-radio>
                    <el-radio label="1">生成中</el-radio>
                    <el-radio label="2">生成失败</el-radio>
                    <el-radio label="3">已生成</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
              <div style="text-align:right">
                <el-button @click="resetSearch" size="small" style="width:100px;">重置</el-button>
                <el-button @click="submitSearch" size="small"
                  style="width:100px;background:#269D7B;color:#fff">确定</el-button>
              </div>
              <el-button size="small" style="margin-left:15px;width:90px;" class="createPingzheng" slot="reference"
                @click="searchModel = true">筛选</el-button>
            </el-popover>
            <el-button  size="small" style="margin-left:10px;" @click="plDelete" v-if="currentType != 1">批量删除</el-button>
            <el-button  size="small" @click="handleBatchClick(2)">批量关联</el-button>
          </div>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <div class="btn_task">
            <el-button slot="reference" size="small" class="createPingzheng" @click="batchModifyTask">批量业务类型</el-button>
            <!-- <el-button @click="handleBatchClick(1)" size="small" class="createPingzheng" >生成凭证</el-button> -->
            <!-- <el-dropdown @command="handleBatchClick">
              <el-button type="primary" size="small" class="createPingzheng">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">生成凭证</el-dropdown-item>
                <el-dropdown-item command="2">关联凭证</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <!-- 生成凭证 -->
						<el-dropdown split-button @click="openTask" size="small" v-if="showBuild">
              生成凭证
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item @click.native="openSetting">生成设置</el-dropdown-item>
                </el-dropdown-menu>
						</el-dropdown>
            <el-button style="width:100px;margin:0 5px;" size="small" @click="exportwater('d', '导出流水明细')"
              v-show="currentType == 1">导出交易流水</el-button>
            <el-button style="width:80px;margin:0 5px;" size="small" :disabled="fkBankContractId == ''"
              @click="btnTask('导入')" v-show="currentType != 1">导入</el-button>
            <el-dropdown style="margin-right:5px" trigger="click" @command="handleCommand"
              v-if="dictList.downList.length > 0 && currentType == 1">
              <el-button size="small">
                电子回单
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item.permission" v-for="(item, index) in dictList.downList" :key="index">{{
                  item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button size="small" @click="openTask">生成凭证</el-button>
            <el-button size="small" @click="openSetting">生成设置</el-button> -->
            <!-- <el-button style="width:90px;" size="small" @click="plDelete" v-if="currentType != 1">批量删除</el-button> -->
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="detailed">
      <div v-for="(item, index) in detailedList" :key="index" class="detailed_item">
        <div class="c9">{{ item.name }}</div>
        <div class="ft">{{ item.value }}</div>
      </div>
    </div>
    <PublicTable :table="tableData" style="margin-top:10px;">
      <template slot-scope="props" slot='transTime'>
        <span>{{ $util.formatDate.format(props.scope.row.transTime, 'yyyy-MM-dd') }}</span>
      </template>
      <template slot-scope="props" slot="vouhNo">
        <el-button type="text" @click="previewTask(props.scope.row)">{{ props.scope.row.vouhNo }}</el-button>
      </template>
      <template slot-scope="props" slot="businessTypeName">
        <el-select v-model="props.scope.row.fkBusinessTypeId" size="small" placeholder='请选择'
          :disabled="!!props.scope.row.fkVoucherChiefId" @change="handleTypeChange($event, props.scope.row)">
          <el-option v-for="item in businessTypeList.filter(x => (x.type + 1) == props.scope.row.drcrf)" :key="item.id"
            :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot-scope='props' slot='recipName'>
        <div style="text-align:left;">
          <div>{{ props.scope.row.recipName }}</div>
          <div>{{ props.scope.row.recipAcc }}</div>
        </div>
      </template>
      <template slot-scope="props" slot="balance">
        <div>{{ currencys(props.scope.row.balance) }}</div>
      </template>
      <template slot-scope="props" slot="receiptState">
        <div :class="{ 'acc-link': props.scope.row.receiptState == 3 }"
          @click="handleView(props.scope.row)">
          {{ formartReceiptState[props.scope.row.receiptState] ? formartReceiptState[props.scope.row.receiptState] :
            "" }}
        </div>
      </template>
      <!-- <template slot-scope="props" slot="operation">

        <el-button type="text" :class="item.name == '删除' && !item.disabled ? 'errorColor' : ''"
          @click="tableTask(item.name, props.scope.row)" :disabled='disabled_pingzheng(item, props.scope.row)'
          v-for="item in btns" :key='item.id'>{{ item.name }}</el-button>
      </template> -->
    </PublicTable>
    <div style="margin-top: 20px;display:flex;justify-content:flex-end;">
      <el-pagination @size-change="pageSizeChange" @current-change="pageIndexChange" @prev-click="pageIndexChange"
        @next-click="pageIndexChange" layout="total, prev, pager, next, sizes, jumper" :total="page.totall"
        :current-page="page.currentPage" :page-size="page.maxResult" :page-sizes="[10,20,30, 50, 100, 200 , 300]"></el-pagination>
    </div>
    <!-- 新增银行 -->
    <AddBlank ref='addBlank' @cancle="cancleTask" @success_tip='successTip'></AddBlank>
    <!-- 生成凭证 -->

    <!-- 导入银行对账单-->
    <ImportBlankBill ref="blankBill" @importExcel='importExcel'></ImportBlankBill>
    <!-- 导出明细 -->
    <Exportdetail :visible="exportss" @refresh="refreshexport" @clearSelect="clearSelect"></Exportdetail>
    <!-- 修改业务类型 -->
    <EditBussinessType ref='editType' @editType="editType"></EditBussinessType>
    <!-- 修改凭证  -->
    <EditVoucher :visible="XG_voucherShow" :row="rows" :openButton_s='openButton_s'
      @on-close-dialog="cancel($event, 'edit')" @on-success-submit="successEdit" @refreshTable='findStatementList'
      v-if="XG_voucherShow"></EditVoucher>
    <!-- 关联凭证 -->
    <ConnectVoucher :visible="voucherVisible" @close="voucherVisible = false" :ids='ids' @success="successTip"
      :type="2" />
    <!-- 批量修改业务类型 -->
    <BatchModifyType ref="batchModifyType" :businessTypeList="businessTypeList" @refrensh="findStatementList"></BatchModifyType>
    <!-- 生成凭证 -->
		<new-addvoucher-dialog
			:newAddVoucherDialogShow.sync='newAddVoucherDialogShow'
			:ids='ids'
			:voucherTemplateList='voucherTemplateList'
      :type="2"
      :settingType="settingType"
      :generateType="generateType"
			@refreshTable='resetSearch'
		>
    </new-addvoucher-dialog>
    <!-- 生成凭证设置 -->
    <BuildSettings ref="buildSettings" @refresh="getSetting"/>
  </div>
</template>

<script>
import { currencys } from "@/assets/utils/currencyFormat";
import EditVoucher from '@/components/table/editVoucher';
import newAddvoucherDialog from '@/components/dialog/newAddVoucherDialog'
import EditBussinessType from '@/components/dialog/editBussinessType';
import Waterdetail from "@/components/bankwater/waterDetail.vue";
import { getLocalTime } from '@/assets/utils/index'
import PublicTable from '@/components/publicTable'
import AccountingPeriod from '@/components/dialog/accountingPeriod'
import AddBlank from '@/components/dialog/addBlank'
import ImportBlankBill from '@/components/dialog/importBlankBill'
import { getAllBankNo, getStatisticsInfo, getStatementList, deleteBankStatement, generateVoucher, voucherPreview, deleteBatch, findAllBankBusinessType, updateBankBusinessType,findInvoiceStatementHistory } from '@/api'
import Exportdetail from "@/components/bankwater/exportdetail.vue";
import { RouterView } from "vue-router";
import ConnectVoucher from "@/components/common/connect-voucher.vue"
import BatchModifyType from '@/components/bankwater/BatchModifyType.vue';
import BuildSettings from '@/components/dialog/BuildSettings'
export default {
  components: {
    BuildSettings,
    newAddvoucherDialog,
    BatchModifyType,
    EditVoucher,
    EditBussinessType,
    Waterdetail,
    Exportdetail,
    ImportBlankBill,
    AccountingPeriod,
    PublicTable,
    AddBlank,
    ConnectVoucher
  },
  watch: {
    currentType: {
      handler(val) {
        if (val == 1) {
          this.btns = this.btns.filter(e => {
            if (e.name == '删除') {
              e.disabled = true
            }
            return e
          })
        } else {
          this.btns = this.btns.filter(e => {
            e.disabled = false
            return e
          })
        }
      },
      immediate: true
    },
    fkBankContractId: {
      handler(val) {
        if (!val) return
        const key = this.blank_list.some(e => e.bankCardNo == val && !e.fkSubjectId)
        const data = this.blank_list.filter(e => e.bankCardNo == val)
        if (key) {
          this.$message.warning('请先设置科目')
          this.$refs.addBlank.hanldeOpen('选择科目', data[0], true, this.currentType)
        }
      },
      immediate: true
    },
  },
  data() {
    return {
      showBuild:false,
      settingType:'0',
      generateType:'0',
      generateList:[],
      voucherTemplateList:[],
      newAddVoucherDialogShow:false,
      voucherVisible: false,
      formartReceiptState: {
        "0": "未生成",
        "1": "生成中",
        "2": "生成失败",
        "3": "已生成",
      },
      currencys,
      pingzhengInfo: "",
      openButton_s: false,
      XG_voucherShow: false, //修改凭证modal
      rows: {}, //修改凭证列表数据
      ids: '',
      selectList: [],
      loading: false,
      detail: {
        showdialog: false,
        row: "",
        moneyTypeList: ""
      },
      getLocalTime,
      page: {
        totall: 0,
        maxResult: 10,
        currentPage: 1
      },
      searchModel: false,
      disabledDate: '',
      pickerOptions: {
        disabledDate: time => {
          //  var Tdate = new Date();
          //     return (
          //     date.getTime() < new Date(aa).getTime() ||
          //     new Date(Tdate.getFullYear(), Tdate.getMonth() + 1, 0).getTime() <=
          //     new Date(date.getFullYear(), date.getMonth(), 0).getTime()
          // );
          return time.getTime() < new Date(`${this.disabledDate}-1`).getTime()
        }
      },
      dictList: {
        downList: [],
        otheroBtn: []
      },
      exportss: {
        showdialog: false,
        tit: "",
        type: "",
        selrows: [],
        bankNo: "",
        signDate: ""
      },
      currentType: '', //1 电子回单  //2 新建银行
      search_form: {
        yearMonth: "",
        voucherType: '0',
        incomeType: 'all',
        receiptState: "all"
      },
      cid: '',
      fkBankContractId: '',
      btns: [
        {
          disabled: false,
          name: '凭证'
        },
        {
          disabled: false,
          name: '删除'
        }
      ],
      blank_list: [],
      detailedList: [
        {
          name: '本期笔数',
          sign: 'num',
          value: '',
        },
        {
          name: '本期收入',
          sign: 'income',
          value: '',
        },
        {
          name: '本期支出',
          sign: 'expenditure',
          value: '',
        },
        {
          name: '账户余额',
          sign: 'balance',
          value: '',
        }
      ],
      businessTypeList: [],
      tableData: {
        border: true,				// 是否带有纵向边框
        stripe: true,				// 是否带有斑马纹
        loading: false,		// 是否显示加载动画
        hasSelect: true,			// 是否显示多选
        hasOperation: false,		// 是否有操作功能
        hasContextmenu: false,		// 是否有右键功能
        hasShowSummary: false,		// 是否显示合计行
        hasShowPagination: false,	// 是否显示分页
        key: 0,
        data: [],
        center: {
          textAlign: 'center',
        },
        config: [
          {
            label: '交易日期',
            value: 'transTime',
            show: 'template',
          },
          {
            label: '凭证号',
            value: 'vouhNo',
            show: 'template',
          },
          {
            label: '对方账户',
            value: 'recipName',
            show: 'template',
          },
          {
            label: '业务类型',
            value: 'businessTypeName',
            show: 'template',
          },
          {
            label: '收入金额',
            value: 'amount_income',
            show: 'normal',
          },
          {
            label: '支出金额',
            value: 'amount_output',
            show: 'normal',
          },
          {
            label: '备注摘要',
            value: 'summary',
            show: 'normal',
          },
          {
            label: '余额',
            value: 'balance',
            show: 'template'
          },
          {
            label: "回单状态",
            value: "receiptState",
            show: 'template',
          },
          // {
          //   label: '操作',
          //   value: 'operation',
          //   show: 'template',
          // },
        ],
        toggleRowSelection: this.toggleRowSelection,
        selectable: this.selectable,
      },
    }
  },
  created() {
    this.cid = sessionStorage.getItem('cid');
    let currentDate = new Date();
		let pastDate = new Date();
		pastDate.setDate(currentDate.getDate() - 180);
		this.search_form.yearMonth = [pastDate,new Date()]
    this.init()
    this.initVouchers()
    this.getAllType()
    // this.getButton();
  },
  activated() {
    // 判断路由有无参数
    let fkBillId = "";
    const queryInfo = this.$route.query
    if (queryInfo.fkBillId) {
      fkBillId = queryInfo.fkBillId;
      // 重置路由参数
      window.history.replaceState(null, null, 'bank_running_water')
    }
    this.getBankList(fkBillId);
    this.getSetting();
  },
  methods: {
    //获取生成设置
    getSetting(){
      findInvoiceStatementHistory({key:'bank_statement'}).then(res=>{
        if(res.data.code==1){
          console.log(res.data)
          this.settingType = res.data.data
        }
      })
    },
    openSetting(){
      this.$refs.buildSettings.openTask('bank_statement',this.settingType)
    },
    openTask(){
       if (this.ids.length == 0) {
        this.$message.warning('请选择数据')
        return
      }
      // if(this.settingType=='0'){
      //    this.btnTask('生成凭证')
      //    return 
      // }
      // this.generateType = this.settingType=='0'?1:2
      this.generateType = 2
      this.newAddVoucherDialogShow = true
      // console.log(111)
    },
    editTask(val){
       this.$refs.addBlank.hanldeOpen('修改银行', val)
      console.log(val)
    },
    generateTask(){},
    // 获取按钮权限
    // getButton(){
    //   let params = 'ac:invoice:singleSave,ac:invoice:mergeSave'
    //   try {
		// 			this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
		// 				if(res.data&&res.data.code==1){
		// 					this.rightButtonList = res.data.data;
    //           console.log(this.rightButtonList)
		// 				}
		// 			})
		// 		}catch(e){

		// 		}
    // },
    // 批量修改业务类型 
    batchModifyTask(){
      if (this.ids.length == 0) {
        this.$message.warning('请选择数据')
        return
      }
      //获取当前选中的类型
      let types = []
      types = this.selectList.map(e=>e.drcrf)
      console.log(types)
      
      this.$refs.batchModifyType.openTask(this.ids,types)
    },
    // 业务类型改变
    handleTypeChange(e, row) {
      let params = {
        id: row.id,
        businessTypeId: e
      }
      updateBankBusinessType(params).then(res => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg)
          row._fkBusinessTypeId = e;
        } else {
          row.fkBusinessTypeId = row._fkBusinessTypeId;
        }
      })
    },
    /** 获取业务类型 */
    getAllType() {
      findAllBankBusinessType().then(res => {
        if (res.data.code == 1) {
          let datas = res.data.data
          this.businessTypeList = datas
        }
      })
    },
    // 批量操作
    handleBatchClick(e,i) {
      if (e == 1) {
        // 批量生成凭证
        if (this.ids.length == 0) {
          this.$message.warning('请选择数据')
          return
        }
        if(i.permission=='ac:bank:singleSave'){
          this.btnTask('生成凭证')
          return
        }
        this.generateType = i.permission==='ac:bank:singleSave'?1:2
        this.newAddVoucherDialogShow = true
      } else if (e == 2) {
        // 批量关联凭证
        this.voucherVisible = true;
      }
    },
    // 点击回单状态
    handleView(row) {
      if (row.receiptState != 3) return;
      let token = sessionStorage.getItem('token')
      let cid = sessionStorage.getItem('cid')
      const router = this.$router.resolve({
        path: 'bankStatement/printReceiptPDF',
        query: {
          serialNos: row.serialNo,
          token,
          cid
        }
      })
      window.open(this.$rootUrl + router.href, '_blank');
    },
    selectable(row) {
      if (row.vouhNo) {
        return false
      } else {
        return true
      }
    },
    initVouchers() {
      const _ = this;
      _.$http.post('voucherChief/initializationVoucher', {}).then((res) => {
        if (res && res.data.code == '1') {
          let datas = res.data.data;
          datas.date = _.$util.formatDate.format(datas.date, 'yyyy-MM-dd');
          _.$setSessionStorage('voucher', res.data.data);
          _.$resert(_.voucher, datas);
        }
      }).catch((e) => {

      });
    },
    plDelete() {
      if (this.ids.length == 0) {
        this.$message.warning('请选择数据')
        return
      }
      this.$confirm('此操作将永久删除选中的数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBatch({ ids: this.ids }).then(res => {
          if (res.data.code == 1) {
            this.$message.success('删除成功')
            this.findStatementList()
            this.getImportInfo()
          }
        })
        // this.getBusinessType()
      })
      // this.deleteTask({isMutilple:true})
    },
    /** 凭证预览查询 */
    findPingZhengInfo(val) {
      voucherPreview({ id: val.id }).then(res => {
        if (res.data.code == 1) {
          let info = res.data.data
          info.preVoucherAddendumList = info.voucherAddendumVoList
          info.date = new Date(info.date)
          this.rows = this.$lodash.cloneDeep(info)
          this.XG_voucherShow = true
        }
      })
    },
    disabled_pingzheng(item, row) {
      let key = item.disabled
      if (item.name == '凭证' && (row.fkVoucherChiefId || !row.fkBusinessTypeId)) {
        key = true
      }
      if (item.name == '修改' && (row.fkVoucherChiefId)) {
        key = true
      }
      return key
    },
    previewTask(row) {
      this.rows = { id: row.fkVoucherChiefId };
      this.XG_voucherShow = true;
    },

    cancel(val, key) {
      this.XG_voucherShow = val;
      // this.openButton_s = false;
      // if(key){

      // }else{
      // 	this.getTableData(this.form);
      // }
    },
    successEdit(val) {//修改成功后的回调
      if (val) {
        let obj = val.data
        obj.type = this.rows.type
        obj.fkId = this.rows.fkId
        obj.carryOverProfitAndLoss = this.rows.carryOverProfitAndLoss
        console.log(val);
        this.$http.post('/voucherChief/save', obj).then(res => {
          if (res.data.code == 1) {
            this.$message.success('保存成功')
            this.XG_voucherShow = false
            this.findStatementList()
          }

        })
        // this.getTableData(this.form);
      }
    },
    editType() {
      this.findStatementList()
    },
    tableTask(type, row) {
      if (type == '凭证') {
        this.findPingZhengInfo(row)
      } else if (type == '修改') {
        this.$refs.editType.handleOpen(row)
      } else if (type == '删除') {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteWater(row.id)
        })
      }
    },
    deleteWater(id) {
      deleteBankStatement({ id }).then(res => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg)
          this.getImportInfo()
          this.findStatementList()
        }
      })
    },
    toggleRowSelection(val) {
      this.exportss.selrows = val
      const ids = val.map(item => item.id);
      this.selectList = val
      this.ids = ids.toString();
    },
    refreshdetail(parm) {
      //交易流水明细
      this.$set(this.detail, "showdialog", parm);
    },
    importExcel() {
      this.getImportInfo()
      this.findStatementList()
    },
    pageSizeChange(val) {
      //每页数量变化事件
      this.page.maxResult = val;
      let pages = this.page.currentPage;
      // this.init(pages, val);
      this.findStatementList()
    },
    pageIndexChange(val) {
      //页码数量变化事件
      this.page.currentPage = val;
      let size = this.page.maxResult;
      // this.init(val, size);
      this.findStatementList()
    },
    getAllPremissionMenu() {
      const _ = this;
      _.dictList.downList.splice(0);
      _.dictList.otheroBtn.splice(0);

      _.$http
        .post("sys/menu/findPermissionMenu", {
          permissions:
            "ac:bank:getReceipt,ac:bank:downReceiptPDF,ac:bank:printReceiptPDF"
        })
        .then(res => {
          if (res && res.data.code == 1) {
            _.dictList.downList = res.data.data;
          }
        });
      _.$http
        .post("sys/menu/findPermissionMenu", {
          permissions:
            "ac:bank:exportStatement,ac:bank:openAccount,ac:bank:contract,ac:bank:breakContract"
        })
        .then(res => {
          if (res && res.data.code == 1) {
            _.dictList.otheroBtn = res.data.data;
          }
        });
       _.$http
        .post("sys/menu/findPermissionMenu", {
          permissions:
            "ac:bank:buildShow,ac:bank:buildSetting"
        })
        .then(res => {
          if (res && res.data.code == 1) {
            _.generateList = res.data.data
            _.showBuild = _.generateList.some(e=>e.permission=='ac:bank:buildShow')
            console.log(_.showBuild)
            // _.dictList.downList = res.data.data;
          }
        });
    },
    clearSelect() {
      // this.$refs.waterRefs.clearSelection();
      this.exportss.showdialog = false;
      this.exportss.selrows.splice(0);
    },
    refreshexport(parm) {
      //导出流水明细
      this.$set(this.exportss, "showdialog", parm);
    },
    exportwater(type, str) {
      //导出流水明细
      this.exportss.showdialog = true;
      this.exportss.tit = str;
      this.exportss.type = type;
    },
    handleCommand(item) {
      const bankObj = this.blank_list.find(i => i.bankCardNo == this.fkBankContractId);
      this.exportss.bankNo = bankObj.bankNum;
      if (item == "ac:bank:getReceipt") {
        this.exportwater("a", "生成电子回单");
      } else if (item == "ac:bank:downReceiptPDF") {
        this.exportwater("b", "下载电子回单");
      } else if (item == "ac:bank:printReceiptPDF") {
        this.exportwater("c", "打印电子回单");
      }
    },
    resetSearch() {
      this.search_form.voucherType = '0'
      this.search_form.incomeType = 'all'
      this.search_form.receiptState = 'all'
      let currentDate = new Date();
      let pastDate = new Date();
      pastDate.setDate(currentDate.getDate() - 180);
      this.search_form.yearMonth = [pastDate,new Date()]
      this.page = {
        totall: 0,
        maxResult: 10,
        currentPage: 1
      }
      this.findStatementList({})
      this.getImportInfo()
      this.searchModel = false
    },
    submitSearch() {
      this.searchModel = false
      this.page.currentPage = 1
      this.findStatementList()
      this.getImportInfo()
    },
    init() {
      this.getAllPremissionMenu()
    },
    successTip() {
      this.getBankList()
    },
    /** 流水列表查询 */
    findStatementList(fkBillId) {
      let params = {
        maxResult: this.page.maxResult,
        currentPage: this.page.currentPage,
        bankContractId: this.fkBankContractId,
        fkBillId: fkBillId || "",
        startTime:this.search_form.yearMonth&&this.search_form.yearMonth.length?this.$util.formatDate.format(this.search_form.yearMonth[0], 'yyyy-MM-dd'):"",
        endTime:this.search_form.yearMonth&&this.search_form.yearMonth.length?this.$util.formatDate.format(this.search_form.yearMonth[1], 'yyyy-MM-dd'):'',
        voucherType: this.search_form.voucherType,
        incomeType: this.search_form.incomeType,
        receiptState: this.search_form.receiptState
      }
      this.loading = true
      getStatementList(params).then(res => {
        if (res.data.code == 1) {
          this.tableData.data = res.data.data.list.filter(e => {
            if (e.amount > 0) {
              this.$set(e, 'amount_income', this.currencys(e.amount))
            } else {
              this.$set(e, 'amount_output', this.currencys(String(e.amount).replace('-', '')))
            }
            e._fkBusinessTypeId = e.fkBusinessTypeId;
            return e
          })
          this.page.totall = Number(res.data.data.totalCount)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    /** 获取当期导入的统计信息 */
    getImportInfo() {
      let startTime = this.$util.formatDate.format(this.search_form.yearMonth[0], 'yyyy-MM-dd')
      let endTime = this.$util.formatDate.format(this.search_form.yearMonth[1], 'yyyy-MM-dd')
      getStatisticsInfo({ fkBankContractId: this.fkBankContractId, startTime: startTime || '', endTime: endTime || '' }).then(res => {
        if (res.data.code == 1) {
          const info = res.data.data
          this.detailedList = this.detailedList.filter((e, key) => {
            for (let i in info) {
              if (e.sign == i) {
                e.value = info[i]
              }
            }
            return e
          })
        }
      })
    },
    /** 获取银行列表 */
    getBankList(fkBillId) {
      getAllBankNo({ cid: this.cid }).then(res => {
        if (res.data.code == 1) {
          this.blank_list = res.data.data
          if (res.data.data.length != 0) {
            this.fkBankContractId = this.fkBankContractId ? this.fkBankContractId : res.data.data[0].bankCardNo
            this.currentType = this.currentType ? this.currentType : res.data.data[0].type
            this.disabledDate = this.disabledDate ? this.disabledDate : res.data.data[0].creatData
            this.getImportInfo()
            this.findStatementList(fkBillId)
          }
          this.blank_list.push({ abbreviation: '+' })
        }
      })
    },
    btnTask(name) {
      if (name == '导入') {
        this.$refs.blankBill.hanldeOpen(this.fkBankContractId, this.blank_list)
      } else if (name == '生成凭证') {
        if (!this.ids.length) {
          this.$message.warning("请选择数据")
          return
        }
        // const key = this.selectList.some(e=>e.fkVoucherChiefId||!e.fkBusinessTypeId)
        // if(key){
        //     this.$message.warning('选择的数据中存在已生成或是未选择业务类型')
        //     return
        // }
        this.$confirm('是否生成选中的数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          generateVoucher({ ids: this.ids }).then(res => {
            if (res.data.code == 1) {
              if (res.data.data.length) {
                res.data.data.forEach(e => {
                  this.$message(e)
                })
              }
              // this.$message.success('生成成功')
              this.findStatementList()
            }
          }).finally(() => {
            this.loading = false
          })
        })
      }
    },
    cancleTask() {
      if (this.blank_list.length >= 2) {
        this.fkBankContractId = this.blank_list[0].bankCardNo
        this.findStatementList()
      } else {
        this.fkBankContractId = ''
      }
      this.$forceUpdate();
    },
    changeBlank_Task(val) {
      if (val) {
        this.fkBankContractId = val
        const arr = this.blank_list.filter(e => e.bankCardNo == val)
        if (arr.length) {
          this.currentType = arr[0].type
          this.disabledDate = arr[0].creatData
        }
        this.findStatementList()
      } else {
        this.$refs.addBlank.hanldeOpen('新增银行')
      }
      if (this.fkBankContractId) {
        this.getImportInfo()
      }
    },
    defaultTime(data) {
      const year = new Date(data.yearPeriodsStart)
      const month = this.$util.formatDate.format(data.yearPeriodsStart, 'yyyyMM')
    },
  },
}
</script>

<style lang='less' scoped>
.createPingzheng {
  background: #269D7B;
  color: #fff;
  border: #269D7B;
}

.errorColor {
  color: rgba(255, 96, 16, 1);
}

.c6 {
  color: #666666;
}

.c9 {
  color: #999999;
}

.ft {
  font-weight: bold;
}

.bank_running_water {
  background: #fff;
  padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 152px);

  .header_change {
    line-height: 32px;
    margin-bottom: 20px;

    .zhangqi_change {}

    .btn_task {}

  }

  .detailed {
    display: flex;

    .detailed_item {
      display: flex;
      width: 24.5%;
      height: 80px;
      margin-right: 0.6%;
      background: rgba(233, 233, 233, .26);
      border-radius: 4px;
      justify-content: space-between;
      padding: 15px 0;
      box-sizing: border-box;
      align-items: center;
      flex-direction: column;
      color: #666666;

      &:last-child {
        margin-right: 0;
      }

      &:first-child {
        >div {
          color: #666666;
        }
      }

      &:nth-child(2) {
        border-left: 4px solid rgba(0, 191, 208, 1);
      }

      &:nth-child(3) {
        border-left: 4px solid rgba(255, 191, 0, 1);
      }

      &:nth-child(4) {
        border-left: 4px solid rgba(38, 138, 255, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashier/bank_running_water.vue